module.exports = __webpack_public_path__ + "static/img/brees2001.8470ba0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees2001.png
// module id = tMmw
// module chunks = 1